const TOUR_UTILS = {
  IMAGES: {
    ARROW_HORIZONTAL_STRAIGHT: 'arrow_horizontal_straight.svg',
    ARROW_TOP_STRAIGHT: 'arrow_top_straight.svg',
    ARROW_RIGHT_CURVED: 'arrow_right_curved.svg',
    ARROW_LEFT_CURVED: 'arrow_left_curved.svg'
  },
  ARROW_OPTIONS: {
    CURVED_ARROWS: {
      TOP_CURVE: 'top',
      BOTTOM_CURVE: 'bottom'
    },
    STRAIGHT_ARROWS: {
      LEFT_DIRECTION: 'left',
      RIGHT_DIRECTION: 'right'
    }
  }
};

export const CONSTANTS = {
  APP: {
    ENV: `${process.env.VUE_APP_ENV}`,
    BASE_URL: `${process.env.VUE_APP_BASE_URL}`
  },
  API: {
    BASE_URL: `${process.env.VUE_APP_FUTALIS_API_URL}`,
    OAUTH_STRATEGY: 'BOTH',
    METHODS: {
      LOG_IN: 'logIn',
      LOG_OUT: 'logOut'
    }
  },
  CONFIGURATOR: {
    MODES: {
      ADD_PET_TO_CLIENT: 'add',
      NEW_PET: 'new',
      EDIT_PET: 'edit'
    },
    allergiesList: {
      54: 'Rind',
      55: 'Huhn',
      57: 'Lamm',
      59: 'Fisch',
      56: 'Ei',
      60: 'Milch',
      53: 'Soja',
      // 46: 'Getreide',
      47: 'Glutenhaltiges Getreide',
      48: 'Reis',
      49: 'Kartoffel',
      51: 'Bohnen',
      61: "Ente",
      62: "Pute",
      63: 'Mais',
      64: "Erbse",
      65: "Hafer"
    },
    allergiesListSort: [59, 54, 57, 61, 62, 55, 56, 60, 49, 48, 47, 51, 53, 63, 64, 65],
    additivesList: {
      1: 'Gelenke',
      2: 'Zähne',
      3: 'Haut & Fell',
      5: 'Herz & Kreislauf'
    },
    illnessesList: {
      1: 'Haut & Fell',
      2: 'Herz-Kreislauf',
      3: 'Gelenke',
      4: 'Verdauung',
      5: 'Niereninsuffizienz',
      6: 'Leberinsuffizienz',
      7: 'Pankreasinsuffizienz',
      8: 'Diabetes mellitus',
      9: 'Herzerkrankung',
      10: 'Verdauungsstörungen',
      11: 'Tumorerkrankungen',
      12: 'Gelenkerkrankungen',
      13: 'Fettstoffwechselstörung (insb. Pankreatitis)'
    },
    whiteList: [4,5,6,13],
    illnessCategoryNames: ["Magen-Darm", "Harnsteine", "Stoffwechsel", "Sonstige Erkrankungen", "Spezielle Wünsche"],
    illnessesCategories: [
      [7, 22, 26, 23, 28, 25, 24, 27], //magenDarm
      [14, 15, 16, 17, 33], //harnsteine
      [8, 20, 18, 19, 34], //stoffwechsel
      [35, 9, 11, 21, 29], //sonstigeErkrankungen
      [30, 31, 32, 36, 37], //spezielleWunsche
    ],
    LAYOUT_WIDTH_BREAKPOINT: 1024,
    SUPPLEMENTS: {
      naElements: ['rfe', 'nfe', 'dm', 'rohfaser', 'rfa'],
      VET_FORM: {
        TOP_ELEMENTS_FIELDS: ['vrp', 'rfe', 'rfa', 'ra'],
        NOT_DISPLAYED_ELEMENTS: ['me', 'nfe', 'dm']
      },
      TYPES: {
        WET: 2,
        DRY: 1
      },
      CHARTS: {
        elementsToRemove: ['dm', 'rfe', 'ra', 'nfe', 'rfa']
      },
      ELEMENT_UNIT_TYPES: {
        UNIT_TYPE_MG: 'mg',
        UNIT_TYPE_MIG: 'μg',
        UNIT_TYPE_IE: 'IE'
      },
      ICONS: {
        CATEGORY_ID__ICON_CLASS_NAME: {
          1: 'icon-chicken',
          2: 'icon-beef',
          3: 'icon-calf',
          4: 'icon-sheep-head',
          5: 'icon-lamb',
          6: 'icon-pork',
          7: 'icon-rabbit',
          8: 'icon-sausage',
          9: 'icon-fish',
          10: 'icon-cheese',
          11: 'icon-eggs',
          12: 'icon-wheat',
          13: 'icon-apple',
          14: 'icon-broccoli',
          15: 'icon-acorn',
          16: 'icon-oil-jar',
          17: 'icon-leaf',
          18: 'icon-bowl-full',
          20: 'icon-deer-head',
          21: 'icon-bone'
        }
      }
    }
  },
  ADDRESSBOOK: {
    CUSTOMER_FORM_DISPLAY_MODES: {
      EDIT_MODE: 'edit',
      DISPLAY_INFORMATION: 'info',
      NEW_CLIENT: 'new'
    },
    MOUNT_ACTIONS: {
      DISPLAY_PET: 'DISPLAY_PET',
      DISPLAY_CLIENT: 'DISPLAY_CLIENT',
      DISPLAY_NEW_CLIENT_FORM: 'DISPLAY_NEW_CLIENT_FORM',
      ASSIGN_PET_TO_CLIENT: 'ASSIGN_PET_TO_CLIENT',
      SELECT_PET_FOR_CLIENT: 'SELECT_PET_FOR_CLIENT'
    }
  },
  DOCS: {
    TYPES: {
      CLIENT_DOCS: 'client-docs',
      PET_DOCS: 'pet-docs'
    }
  },
  GUIDED_TOUR: {
    ACTIONS: {
      START_TOUR: 'START_TOUR',
      NONE: 'NONE',
      STOP_TOUR: 'STOP_TOUR',
      NEXT_STEP: 'NEXT_STEP',
      PREVIOUS_STEP: 'PREVIOUS_STEP'
    },
    SECTIONS: {
      orphanPets: ['ORPHAN_PET_0', 'REPLAY_GUIDED_TOUR_TRIGGER'],
      Home: [
        'HEADER_ADDRESS_BOOK_BUTTON',
        'NEW_ANONYMOUS_RATION',
        'new-patient',
        'orphan-dogs',
        'cog-wheel',
        'REPLAY_GUIDED_TOUR_TRIGGER',
        'HEADER_FUTALIS_LOGO'
      ],
      RationResults: [
        'RATION_TABLE',
        'RATION_PRUFEN_BUTTON',
        'PRINT_BUTTON_WRAPPER'
      ],
      RationCheck: [
        'WELCOME_SCREEN',
        'FOOD_BOOKLET_TRIGGER',
        'FOOD_BOOKLET_CATEGORIES_TILE',
        'FOOD_BOOKLET_SUPPLEMENTS_TILE',
        'FOOD_BOOKLET_QUANTITIES_TILE',
        'RATION_TABLE',
        'RATION_CHARTS_TABS'
      ]
    },
    ARROW_OPTIONS: {
      Home: {
        REPLAY_GUIDED_TOUR_TRIGGER: {
          image: TOUR_UTILS.IMAGES.ARROW_TOP_STRAIGHT,
          color: '#ffffff'
        },
        HEADER_ADDRESS_BOOK_BUTTON: {
          image: TOUR_UTILS.IMAGES.ARROW_TOP_STRAIGHT,
          color: '#ffffff'
        },
        NEW_ANONYMOUS_RATION: {
          image: TOUR_UTILS.IMAGES.ARROW_LEFT_CURVED,
          curve: TOUR_UTILS.ARROW_OPTIONS.CURVED_ARROWS.BOTTOM_CURVE,
          color: '#ffffff'
        },
        'orphan-dogs': {
          image: TOUR_UTILS.IMAGES.ARROW_LEFT_CURVED,
          curve: TOUR_UTILS.ARROW_OPTIONS.CURVED_ARROWS.TOP_CURVE,
          color: '#ffffff'
        },
        'vet-logo': {
          image: TOUR_UTILS.IMAGES.ARROW_LEFT_CURVED,
          curve: TOUR_UTILS.ARROW_OPTIONS.CURVED_ARROWS.BOTTOM_CURVE,
          color: '#ffffff'
        },
        'new-patient': {
          image: TOUR_UTILS.IMAGES.ARROW_RIGHT_CURVED,
          curve: TOUR_UTILS.ARROW_OPTIONS.CURVED_ARROWS.BOTTOM_CURVE,
          color: '#ffffff'
        },
        HEADER_FUTALIS_LOGO: {
          image: TOUR_UTILS.IMAGES.ARROW_RIGHT_CURVED,
          curve: TOUR_UTILS.ARROW_OPTIONS.CURVED_ARROWS.TOP_CURVE,
          color: '#ffffff'
        },
        'cog-wheel': {
          image: TOUR_UTILS.IMAGES.ARROW_HORIZONTAL_STRAIGHT,
          direction: TOUR_UTILS.ARROW_OPTIONS.STRAIGHT_ARROWS.LEFT_DIRECTION, // left or right
          color: '#ffffff'
        }
      },
      RationResults: {
        RATION_TABLE: {
          image: TOUR_UTILS.IMAGES.ARROW_RIGHT_CURVED,
          curve: TOUR_UTILS.ARROW_OPTIONS.CURVED_ARROWS.BOTTOM_CURVE,
          color: '#BCCF00'
        },
        RATION_PRUFEN_BUTTON: {
          image: TOUR_UTILS.IMAGES.ARROW_LEFT_CURVED,
          curve: TOUR_UTILS.ARROW_OPTIONS.CURVED_ARROWS.TOP_CURVE,
          color: '#BCCF00'
        },
        PRINT_BUTTON_WRAPPER: {
          image: TOUR_UTILS.IMAGES.ARROW_RIGHT_CURVED,
          curve: TOUR_UTILS.ARROW_OPTIONS.CURVED_ARROWS.BOTTOM_CURVE,
          color: '#BCCF00'
        }
      },
      RationCheck: {
        WELCOME_SCREEN: {
          image: TOUR_UTILS.IMAGES.ARROW_TOP_STRAIGHT,
          color: 'transparent'
        },
        FOOD_BOOKLET_TRIGGER: {
          image: TOUR_UTILS.IMAGES.ARROW_LEFT_CURVED,
          curve: TOUR_UTILS.ARROW_OPTIONS.CURVED_ARROWS.BOTTOM_CURVE,
          color: '#ffffff'
        },
        FOOD_BOOKLET_CATEGORIES_TILE: {
          image: TOUR_UTILS.IMAGES.ARROW_HORIZONTAL_STRAIGHT,
          direction: TOUR_UTILS.ARROW_OPTIONS.STRAIGHT_ARROWS.LEFT_DIRECTION,
          color: '#ffffff'
        },
        FOOD_BOOKLET_SUPPLEMENTS_TILE: {
          image: TOUR_UTILS.IMAGES.ARROW_HORIZONTAL_STRAIGHT,
          direction: TOUR_UTILS.ARROW_OPTIONS.STRAIGHT_ARROWS.LEFT_DIRECTION,
          color: '#ffffff'
        },
        FOOD_BOOKLET_QUANTITIES_TILE: {
          image: TOUR_UTILS.IMAGES.ARROW_HORIZONTAL_STRAIGHT,
          direction: TOUR_UTILS.ARROW_OPTIONS.STRAIGHT_ARROWS.LEFT_DIRECTION,
          color: '#ffffff'
        },
        RATION_TABLE: {
          image: TOUR_UTILS.IMAGES.ARROW_RIGHT_CURVED,
          curve: TOUR_UTILS.ARROW_OPTIONS.CURVED_ARROWS.TOP_CURVE,
          color: '#ffffff'
        }
      },
      orphanPets: {
        ORPHAN_PET_0: {
          image: TOUR_UTILS.IMAGES.ARROW_LEFT_CURVED,
          curve: TOUR_UTILS.ARROW_OPTIONS.CURVED_ARROWS.TOP_CURVE,
          color: '#ffffff'
        }
      }
    },
    SECTIONS_SIBLINGS: {
      Home: {
        'cog-wheel': ['vet-logo', 'contact-logo'],
        'new-patient': ['address-book']
      }
    }
  },
  CONTAINERS: {}
};
